module.exports = __webpack_public_path__ + "static/media/github.81533a6b.png";